import { render, staticRenderFns } from "./CourseUploadEditDialog.vue?vue&type=template&id=37d74a29&"
import script from "./CourseUploadEditDialog.vue?vue&type=script&lang=js&"
export * from "./CourseUploadEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports